import FinanceApi from '@/services/apiService';

/*
  for import conciliable mixins, is necessary import mixin in the component and add into mixins
  attribute.

  for use filtered data is necessary declare the next data in the component:

  return filtered data for country attribute.
    this.search.country (optional)
    this.defaultCountry (optional)
*/

export default {
  data() {
    return {
      BTZconciliables: [],
    };
  },
  beforeMount() {
    this.fetchBTZConciliables();
  },
  methods: {
    fetchBTZConciliables() {
      FinanceApi.getBTZConciliables().then((data) => {
        this.BTZconciliables = data.body;
      });
    },
    filterBTZConciliables(country) {
      return this.BTZconciliables.filter((conciliable) => conciliable.country === country)
        .map((conciliable) => (this.formatBTZConciliable(conciliable)));
    },
    formatBTZConciliable(conciliable) {
      return {
        key: conciliable.name,
        value: conciliable.name,
        id: conciliable.id,
        klass: conciliable.klass,
        idKey: `${conciliable.id}-${conciliable.klass}`,
      };
    },
    getBTZConciliable(idKey) {
      return this.filteredBTZConciliables.find((conciliable) => conciliable.idKey === idKey);
    },
  },
  computed: {
    filteredBTZConciliables() {
      const country = this.search.country || this.defaultCountry;
      let filteredBTZConciliables = this.BTZconciliables;

      if (country) {
        filteredBTZConciliables = filteredBTZConciliables
          .filter((conciliable) => conciliable.country === country);
      }

      return filteredBTZConciliables.map((conciliable) => (this.formatBTZConciliable(conciliable)));
    },
  },
};
